/* import __COLOCATED_TEMPLATE__ from './company-team-tag.hbs'; */
import Component from '@glimmer/component';
import { htmlSafe } from '@ember/template';
import clsx from 'clsx';

const MAX_DESCRIPTION_LENGTH = 31;
const DISABLED_HEX_CODE = '9E9E9E';

class CompanyMembers extends Component {
  get classNames() {
    return clsx(
      'tag company-team',
      this.args.class,
    );
  }

  get canRemoveTeamAssociation() {
    return this.args.canRemoveTeamAssociation && !this.args.disabled;
  }

  get teamColorStyles() {
    const hexCode = this.args.disabled ? DISABLED_HEX_CODE : this.args.companyTeam.colorHex;
    return htmlSafe(`--team-icon-color: #${hexCode};`);
  }

  get teamDescription() {
    const { description } = this.args.companyTeam;
    return description.length > MAX_DESCRIPTION_LENGTH
      ? `${description.substring(0, MAX_DESCRIPTION_LENGTH)}...`
      : description;
  }
}

export default CompanyMembers;
